export const FDIC_NONE = 'None' as const;
export const FDIC_DARK = 'Blue/Black' as const;
export const FDIC_LIGHT = 'White' as const;

export const FDIC_LOGO_OPTIONS = {
  FDIC_NONE,
  FDIC_DARK,
  FDIC_LIGHT
};

export const FDIC_LOGO_VARIANTS = {
  HEADER: 'header',
  LOGIN: 'login'
} as const;

export const FDIC_DISCLAIMER_VARIANTS = {
  OTHER: 'OTHER',
  INVESTMENT: 'INVESTMENT'
} as const;

export const MAX_DISCLAIMER_LENGTH = 100;
